import { Action } from 'redux';

import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';

import { SetSensitiveOrWarningLabelValue } from '../../../bootstrap/redux/actions/AppActionTypes';

export interface SetSensitiveOrWarningLabelValueAction extends Action {
    item: ILabelValueInfo;
}

export function setSensitiveOrWarningLabelValueAction(item: SetSensitiveOrWarningLabelValueAction['item']): SetSensitiveOrWarningLabelValueAction {
    return {
        type: SetSensitiveOrWarningLabelValue,
        item
    };
}
